import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SandboxService } from "./sandbox.service";

const initialState = {
  available: false, // server started with SANDBOX_MODE on
  active: false, // available AND a limit is switched on
  enabled: false,
  mode: "off",
  value: 0,
  label: "",
  banner: null, // { active, mode, value, message } | null
  updatedBy: null,
  updatedAt: null,
  loaded: false,
  isLoading: false,
  isSaving: false,
  error: null,
};

const service = new SandboxService();
const msg = (e, f) => e?.response?.data?.message || e?.message || f;

export const fetchSandbox = createAsyncThunk("sandbox/fetch", async (_, { rejectWithValue }) => {
  try {
    return await service.getConfig();
  } catch (error) {
    return rejectWithValue(msg(error, "Failed to load sandbox settings"));
  }
});

export const updateSandbox = createAsyncThunk("sandbox/update", async (payload, { rejectWithValue }) => {
  try {
    return await service.updateConfig(payload);
  } catch (error) {
    return rejectWithValue(msg(error, "Failed to update sandbox settings"));
  }
});

const applyData = (state, d = {}) => {
  state.available = !!d.available;
  state.active = !!d.active;
  state.enabled = !!d.enabled;
  state.mode = d.mode || "off";
  state.value = Number(d.value) || 0;
  state.label = d.label || "";
  state.banner = d.banner || null;
  state.updatedBy = d.updatedBy || null;
  state.updatedAt = d.updatedAt || null;
};

export const sandboxSlice = createSlice({
  name: "sandbox",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSandbox.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSandbox.fulfilled, (state, action) => {
        state.isLoading = false;
        state.loaded = true;
        state.error = null;
        applyData(state, action.payload?.data);
      })
      .addCase(fetchSandbox.rejected, (state, action) => {
        state.isLoading = false;
        state.loaded = true;
        state.error = action.payload;
      })
      .addCase(updateSandbox.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateSandbox.fulfilled, (state, action) => {
        state.isSaving = false;
        state.error = null;
        applyData(state, action.payload?.data);
      })
      .addCase(updateSandbox.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload;
      });
  },
});

export default sandboxSlice.reducer;
